// ============================================
// Form Field Component
// Reusable form field wrapper with label and error
// ============================================

import React from 'react';

interface FormFieldProps {
  label: string;
  error?: string;
  required?: boolean;
  children: React.ReactNode;
  helpText?: string;
}

const FormField: React.FC<FormFieldProps> = ({
  label,
  error,
  required,
  children,
  helpText,
}) => {
  return (
    <div className="form-field-wrapper">
      <label className="form-field-label">
        {label}
        {required && <span className="form-field-required">*</span>}
      </label>
      <div className={error ? 'form-field-error' : ''}>
        {children}
      </div>
      {helpText && !error && (
        <p className="form-field-help-text">{helpText}</p>
      )}
      {error && (
        <p className="error-message">{error}</p>
      )}
    </div>
  );
};

export default FormField;
